import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getUsersInCsv = (params) => {
    return axios({
        responseType: 'blob', 
        url: `${backendHost}/api/admin/users/csv`, 
        method: 'GET',
        params
    });
};